import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs/operators";

@Component({
  selector: "footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss", "./footer.component.mobile.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent {
  showGrokCredit = false;

  constructor(router: Router, cdr: ChangeDetectorRef) {
    router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe((event) => {
      const path = event.urlAfterRedirects.split("?")[0].split("#")[0];
      this.showGrokCredit = /^\/Mid-South$/i.test(path);
      cdr.markForCheck();
    });
  }
}
